<section id="about-3" class="about-section division">
	<div class="container">
		<div class="abox-3-holder">
			<div class="row d-flex align-items-center">


				<!-- ABOUT BOX #1 -->
				<div class="col-lg-4">
					<div class="abox-3 b-right wow fadeInUp" data-wow-delay="0.4s"
						style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">

						<!-- Small Title -->
						<p class="blue-color">Qualified Doctors</p>

						<!-- Title -->
						<h5 class="h5-xs steelblue-color">Where People Come First</h5>

						<!-- Text -->
						<p>Our team of highly qualified doctors is dedicated to providing expert, personalized care
						</p>

					</div>
				</div>


				<!-- ABOUT BOX #3 -->
				<div class="col-lg-4">
					<div class="abox-3 b-right wow fadeInUp" data-wow-delay="0.6s"
						style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">

						<!-- Small Title -->
						<p class="blue-color">24 Hour Service</p>

						<!-- Title -->
						<h5 class="h5-xs steelblue-color">Highest Quality Care</h5>

						<!-- Text -->
						<p>Experience the highest quality care with advanced treatment and a compassionate touch
						</p>

					</div>
				</div>


				<!-- ABOUT BOX #3 -->
				<div class="col-lg-4">
					<div class="abox-3 wow fadeInUp" data-wow-delay="0.8s"
						style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInUp;">

						<!-- Small Title -->
						<p class="blue-color">Here For You</p>

						<!-- Title -->
						<h5 class="h5-xs steelblue-color">Emergency Department</h5>

						<!-- Text -->
						<p>Our 24/7 Emergency Department delivers fast, reliable, and 
							expert medical attention when it matters most
						</p>

					</div>
				</div>


			</div> <!-- End row -->
		</div> <!-- End container -->
	</div>
</section>

<section id="info-1" class="wide-60 info-section division ">
	<div class="container">
		<div class="row d-flex align-items-center">

			<!-- IMAGE BLOCK -->
			<div class="col-lg-6">
				<div class="info-1-img wow fadeInUp" data-wow-delay="0.6s"
					style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">
					<img class="img-fluid" src="assets/images/image-04.png" alt="info-image">
				</div>
			</div>

			<!-- TEXT BLOCK -->
			<div class="col-lg-6">
				<div class="txt-block pc-30 mb-40 wow fadeInUp" data-wow-delay="0.4s"
					style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">

					<!-- Section ID -->
					<span class="section-id blue-color">Best Practices</span>

					<!-- Title -->
					<h3 class="h3-md steelblue-color">Clinic with Innovative Approach to Treatment</h3>

					<!-- Text -->
					<p class="mb-30">At Movement Clinic, we believe in combining traditional 
						care with modern innovation. Our clinic uses the latest medical technology and 
						evidence-based practices to ensure accurate diagnosis and effective treatment. 
						From digital health records to minimally invasive procedures, we embrace innovation to
						improve patient outcomes. We don’t just treat illnesses — we build personalized treatment 
						plans for long-term wellness. Experience healthcare that evolves with your needs.

					</p>

					<!-- Options List -->
					<div class="row">

						<div class="col-xl-6">

							<!-- Option #1 -->
							<div class="box-list m-top-15">
								<div class="box-list-icon blue-color"><i class="fas fa-angle-double-right"></i>
								</div>
								<p class="p-sm">Personalized, modern treatment plans</p>
							</div>

							<!-- Option #2 -->
							<div class="box-list">
								<div class="box-list-icon blue-color"><i class="fas fa-angle-double-right"></i>
								</div>
								<p class="p-sm">Latest medical technologies used</p>
							</div>

							<!-- Option #3 -->
							<div class="box-list">
								<div class="box-list-icon blue-color"><i class="fas fa-angle-double-right"></i>
								</div>
								<p class="p-sm">Innovation meets patient care</p>
							</div>

						</div>

						<div class="col-xl-6">

							<!-- Option #4 -->
							<div class="box-list">
								<div class="box-list-icon blue-color"><i class="fas fa-angle-double-right"></i>
								</div>
								<p class="p-sm">Fast, accurate diagnostics tools</p>
							</div>

							<!-- Option #5 -->
							<div class="box-list m-top-15">
								<div class="box-list-icon blue-color"><i class="fas fa-angle-double-right"></i>
								</div>
								<p class="p-sm">Smart solutions for recovery</p>
							</div>

							<!-- Option #6 -->
							<div class="box-list">
								<div class="box-list-icon blue-color"><i class="fas fa-angle-double-right"></i>
								</div>
								<p class="p-sm">Care that evolves with you</p>
							</div>

						</div>

					</div> <!-- End Options List -->

				</div>
			</div> <!-- END TEXT BLOCK -->





		</div> <!-- End row -->
	</div> <!-- End container -->
</section>